import FooterPublic from './FooterPublic';

export default FooterPublic;
